import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  loading = new BehaviorSubject<boolean>(false);

  constructor() {}

  showLoading(){
    this.loading.next(true);
  }

  hideLoading(){
    this.loading.next(false);
  }
}
